<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title" id="modal-title-matches">{{ 'Your matches' | translate }}</h5>
    <button tabindex="10" type="button" class="close" aria-label="Close" (click)="close(false)">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="content">
      <p>{{ 'Do you see something interesting? Then click on "Connect".' | translate }}</p>
      <ul>
        <li>{{ "You join the company's network" | translate }}</li>
        <li>{{ 'See current internships and vacancies' | translate }}</li>
      </ul>
    </div>

    @if (isLoading()) {
    <app-loader />
    } @else {
    <div class="grid equal-height grid-network">
      <div class="row">
        @for (match of matches(); track match.company?.id) {
        <div class="col-12 col-lg-4 col-md-6 col-sm-6">
          <app-company-card [data]="match.company!" [roleType]="RoleTypes.Student" (onClickEvent)="onCompanyClick($event)"></app-company-card>
        </div>
        }
      </div>
    </div>
    }
  </div>

  <div class="modal-footer">
    <div class="btn-toolbar flex-grow-1 justify-content-between">
      <button type="button" class="btn btn-lg btn-danger ml-auto mr-auto" data-cy="letsgo" (click)="close(false)">
        {{ "Great, let's go!" | translate }}
      </button>
    </div>
  </div>
</div>
